import { QuoteOriginNames } from '@models/quotes';
import { TypeAheadFilter } from './TypeAheadFilter';
import { TableFilterTypeAheadFilterExtendedProps } from '@components/table/filters/TypeaheadFilterProps.type';
import { useSearchQuoteOrigin } from '@services/quoteOrigin/useSearchQuoteOrigin';

export interface QuoteOriginTypeaheadFilterProps extends TableFilterTypeAheadFilterExtendedProps {}

export function getQuoteOriginLabel(name: string = QuoteOriginNames.Default) {
  const labelOverrides: Record<string, string> = {
    Default: 'Portal',
  };
  return labelOverrides[name] ?? name;
}

export const QuoteOriginTypeaheadFilter = (componentProps: QuoteOriginTypeaheadFilterProps) => {
  const { value, disabled } = componentProps;
  const { items, isFetching } = useSearchQuoteOrigin({ sort: '+name', pageLimit: 100 });

  const options = items.map((item) => ({ key: item.id, label: getQuoteOriginLabel(item.name), value: item.id }));

  return (
    <TypeAheadFilter
      value={value}
      defaultValue={value}
      disabled={disabled}
      label={componentProps.label}
      options={options}
      isMultiple={componentProps?.fieldConfig?.selectField?.multiSelect}
      limitTags={1}
      onChange={componentProps.onChange}
      loading={isFetching}
      horizontalLabel={true}
    />
  );
};
